import { Injectable, inject } from '@angular/core';
import { HttpClient, httpResource } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TenantInfo } from './tenant.models';

/**
 * Owns `GET /api/tenant/me`. Tenant-scoped: the caller is identified by the JWT, so there is no id
 * in the URL, matching AccountService.
 *
 * `me` is a root-scoped httpResource for reactive reads (the shell's nav gating, the agency portal
 * page). `fetchMe` is a plain Observable for the route guard, which needs an awaitable result to
 * resolve navigation rather than a signal.
 */
@Injectable({ providedIn: 'root' })
export class TenantService {
  readonly #http = inject(HttpClient);
  readonly #base = environment.apiUrl;

  readonly me = httpResource<TenantInfo>(() => `${this.#base}/tenant/me`);

  fetchMe(): Observable<TenantInfo> {
    return this.#http.get<TenantInfo>(`${this.#base}/tenant/me`);
  }

  /** `PUT /api/tenant/name` — renames the caller's agency tenant (agency admin only). */
  setName(name: string): Observable<{ readonly name: string }> {
    return this.#http.put<{ readonly name: string }>(`${this.#base}/tenant/name`, { name });
  }
}
